<template>
  <div>
    <Head title="Compras" />

    <!-- 1. Header & Acciones Principales -->
    <ShoppingHeader 
      title="Compras"
      :total-count="(stats?.count_shoppings || 0) + (stats?.count_spents || 0)"
      create-url="/shoppings/create?type=shopping"
      create-label="Crear Compra"
      monthly-report-pdf-url="/spents/monthly-report/pdf"
      @open-quick-spent="showQuickSpentModal = true"
    />

    <!-- 2. Sección de Estadísticas / KPIs -->
    <ShoppingStats :stats="stats" />

    <!-- 3. Barra de Búsqueda, Tabs y Filtros -->
    <ShoppingFilters 
      v-model:search="form.search"
      v-model:tab="form.tab"
      v-model:status="form.status"
    />

    <!-- 4. Tabla y Listado Unificado Principal -->
    <ShoppingTable 
      :items="tableItems"
      :pagination-links="paginationLinks"
      @open-quick-spent="showQuickSpentModal = true"
      @delete-spent="deleteSpent"
    />

    <!-- 5. Modal Rápido de Nuevo Gasto -->
    <ShoppingQuickSpentModal 
      :is-open="showQuickSpentModal"
      :providers="providers"
      :spent-categories="spent_categories"
      :current-exchange-rate="current_exchange_rate"
      @close="showQuickSpentModal = false"
    />
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import Swal from 'sweetalert2'

import ShoppingHeader from './Partials/ShoppingHeader.vue'
import ShoppingStats from './Partials/ShoppingStats.vue'
import ShoppingFilters from './Partials/ShoppingFilters.vue'
import ShoppingTable from './Partials/ShoppingTable.vue'
import ShoppingQuickSpentModal from './Partials/ShoppingQuickSpentModal.vue'

export default {
  name: 'ShoppingIndex',

  components: {
    Head,
    ShoppingHeader,
    ShoppingStats,
    ShoppingFilters,
    ShoppingTable,
    ShoppingQuickSpentModal,
  },

  layout: Layout,

  props: {
    items: {
      type: Object,
      default: () => ({ data: [] }),
    },
    shopping: {
      type: Object,
      default: () => ({ data: [] }),
    },
    stats: {
      type: Object,
      default: () => ({
        total_outflows: 0,
        total_shoppings: 0,
        count_shoppings: 0,
        total_spents: 0,
        count_spents: 0,
      }),
    },
    providers: {
      type: Array,
      default: () => [],
    },
    spent_categories: {
      type: Array,
      default: () => [],
    },
    current_exchange_rate: {
      type: [Number, String],
      default: 0,
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
    user: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      showQuickSpentModal: false,
      form: {
        tab: this.filters.tab || 'all',
        search: this.filters.search || '',
        status: this.filters.status || null,
      },
    }
  },

  computed: {
    tableItems() {
      if (this.items && Array.isArray(this.items.data)) {
        return this.items.data
      }
      if (this.shopping && Array.isArray(this.shopping.data)) {
        return this.shopping.data
      }
      return []
    },

    paginationLinks() {
      if (this.items?.meta?.links) return this.items.meta.links
      if (this.items?.links) return this.items.links
      if (this.shopping?.meta?.links) return this.shopping.meta.links
      if (this.shopping?.links) return this.shopping.links
      return []
    },
  },

  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/shoppings', pickBy(this.form), {
          preserveState: true,
          replace: true,
        })
      }, 300),
    },
  },

  methods: {
    deleteSpent(id) {
      Swal.fire({
        title: '¿Eliminar este gasto?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ef4444',
        cancelButtonColor: '#6b7280',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(`/spents/${id}`, {
            preserveState: true,
            onSuccess: () => {
              Swal.fire({
                icon: 'success',
                title: 'Eliminado',
                text: 'El gasto fue eliminado correctamente.',
                timer: 1500,
                showConfirmButton: false,
              })
            },
          })
        }
      })
    },
  },
}
</script>
